export default {
    getActions: state => state.actions,
    getDataTableOptions: state => state.dataTableOptions,
    getSearchFields: state => state.searchFields,
    getRowActions: state => state.rowActions,
    getHeaderFields: state => state.headerFields,

    getEuPontokRowActions: state => state.euPontokRowActions,
    getEuPontokHeaderFields: state => state.euPontokHeaderFields,
    getBnoCodeRowActions: state => state.bnoCodeRowActions,
    getHeaderBNOCodeFields: state => state.headerBNOCodeFields
}
